<div class="assessment-component">

  <div *ngIf="assessmentId !== null && answers && quiz" style="width: 100%;">
    <p-table [value]="answers"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             #table
             [columns]="columns"
    >
      <ng-template pTemplate="header">
        <tr style="white-space: nowrap; font-weight: bold;">
          <th rowspan="2">User Name</th>
          <th rowspan="2">Date Submitted</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{getFullName(item.userId)}}</td>
          <td><div style="text-decoration: underline; cursor: pointer" (click)="open(item)">{{item.date | date: 'shortDate'}}</div></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
